import { render, staticRenderFns } from "./detail_company.vue?vue&type=template&id=c73307a6&scoped=true&"
import script from "./detail_company.vue?vue&type=script&lang=js&"
export * from "./detail_company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73307a6",
  null
  
)

export default component.exports